export default __webpack_public_path__ + "static/media/gallery_02.013b14b1.jpg";